var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotswana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.089 178.086C4.24698 202.655 -2.3261e-05 228.828 0.000976739 255.999C-2.3261e-05 283.168 4.24698 309.342 12.09 333.912L256.001 345.044L499.911 333.912C507.752 309.342 512 283.167 512 256C512 228.83 507.753 202.655 499.911 178.086L256 166.956L12.089 178.086Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 240.813 510.67 225.937 508.133 211.477H3.868C1.33 225.937 0 240.811 0 255.999C0 271.187 1.331 286.061 3.868 300.521H508.133C510.669 286.06 512 271.186 512 256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 511.999C370.217 511.999 466.947 437.196 499.911 333.911H12.0898C45.0548 437.195 141.786 511.997 256.001 511.999V511.999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 0.000976603C141.786 0.000976603 45.0559 74.804 12.0889 178.086L499.909 178.087C466.946 74.804 370.215 -0.0010234 256.001 0.000976603V0.000976603Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotswana);
export default __webpack_public_path__ + "static/media/botswana.2954c13357b3fd01de036b520a66c5ce.svg";
export { ForwardRef as ReactComponent };